module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inicial-bodies col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 px-0"
  }, [_c('div', {
    staticClass: "inicial-body2 inicial-body-step-2 is-showing"
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('div', {
    staticClass: "formulario-login-topo-logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  })]), _c('button', {
    staticClass: "btn btn-idioma",
    staticStyle: {
      "z-index": "2",
      "position": "relative"
    },
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas && !_vm.logadoSuccess),
      expression: "abrirIdiomas && !logadoSuccess"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.eng')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.esp')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), (!_vm.logadoSuccess) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "45px",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginInputLog",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario'),
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.logadoError) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.erro.login'))
    }
  }) : _vm._e(), (_vm.campoUsernameVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e(), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.passwordPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginSenha",
      "placeholder": _vm.$t('login.placeholders.senha'),
      "type": "password",
      "name": "password",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), (_vm.logadoError) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.erro.senha'))
    }
  }) : _vm._e(), (_vm.campoPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhaVazia'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "recuperarSenha"
  }, [_c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.esqueceuSenha'))
    },
    on: {
      "click": _vm.trocaTelaRecuperarSenha
    }
  })]), (_vm.isProbableABot) ? _c('div', {
    staticClass: "recaptcha-form"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.PUBLIC_KEY,
      "size": "normal"
    },
    on: {
      "verify": _vm.onVerifyLogin
    }
  })], 1) : _vm._e()]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.entrar'),
      "disabled": _vm.disableLoginButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.entrar'))
    }
  })]) : _vm._e(), (_vm.logadoSuccess) ? _c('div', {
    staticClass: "formulario-login logado"
  }, [_c('img', {
    attrs: {
      "src": _vm.logadoOkPng,
      "width": "89",
      "height": "89"
    }
  }), _c('div', {
    staticClass: "logado-ok",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.login'))
    }
  }), _c('div', {
    staticClass: "bem-vindo",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.bemVindo'))
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "inicial-body3 inicial-body-step-3",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid rgba(255, 255, 255, 1)"
    }
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('div', {
    staticClass: "formulario-login-topo-logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  })]), _c('button', {
    staticClass: "btn btn-idioma",
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas),
      expression: "abrirIdiomas"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.recoverPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "45px",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginInputRec",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e(), (_vm.campoUsernameVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e()]), _c('form', {
    staticClass: "recaptcha-form",
    attrs: {
      "action": "?",
      "method": "POST"
    }
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.PUBLIC_KEY,
      "size": "normal"
    },
    on: {
      "verify": _vm.onVerify
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    on: {
      "onclick": _vm.recoverPassword
    }
  })])], 1)]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.recuperarSenha'),
      "disabled": _vm.disableRecoveryButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.recuperarSenha'))
    }
  })])]), _c('button', {
    staticClass: "btn button2",
    attrs: {
      "title": _vm.$t('login.titulos.voltar')
    },
    on: {
      "click": function($event) {
        return _vm.trocaTelaVoltar()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.voltarPng,
      "width": "33",
      "height": "33"
    }
  }), _c('span', {
    staticClass: "text-white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.voltar'))
    }
  })])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "img-bottom"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("ambiente-seguro-")
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("premio-br-week-")
    }
  })]), _c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("certificado-saae18-")
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cb3e11e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb3e11e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/login/login.pug
// module id = 1417
// module chunks = 0